import { RespostaProcessamento } from '../mensagem-controle/resposta-processamento.model';
import { ProcessamentoSituacao } from './processamento-situacao.enum';

export class IdsProcessamento {
  public origemId: string;
  public fonteDados: string;
  public situacao: ProcessamentoSituacao;
  public resultado: RespostaProcessamento;
  public mensagemErro: string;

  constructor(fonteDados: string, origemId: string) {
    this.origemId = origemId;
    this.fonteDados = fonteDados;
    this.situacao = ProcessamentoSituacao.PENDENTE;
    this.resultado = undefined;
    this.mensagemErro = undefined;
  }
}
